import isEqual from 'lodash/isEqual'

let _prevState = {}

/**
 * This function allows you to set the previous state for testing
 */
export const setPrevState = (state) => {

  _prevState = { ...state }

}

/**
 * Returns an array of Twilio Doc properties that have changed
 * @param state The Twilio Doc state
 */
export default function (state): [string, any][] {

  const updated: [string, any][] = []

  for (const [key, value] of Object.entries(state)) {

    if (Reflect.has(_prevState, key) && isEqual(value, _prevState[key])) continue

    updated.push([key, value])

  }

  _prevState = { ...state }

  return updated

}
